import React, { Fragment, useRef, useState, useEffect } from 'react'
import { isEmpty } from 'lodash'
import clsx from 'clsx'

import { IconCopyText } from 'components/Icons'
import { copyToClipboard } from 'helpers/common'
import { useOnClickOutside } from 'helpers/hooks'
import { getLabel } from 'helpers/language'

export interface CopyToClipboardProps {
  url?: string
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = (
  props: CopyToClipboardProps,
): JSX.Element => {
  const [isCopied, setIsCopied] = useState<boolean>(false)
  const { url } = props

  const divRef = useRef<HTMLDivElement>(null)

  const base = 'copy-to-clipboard'
  const isReady = url && !isEmpty(url)

  useOnClickOutside(divRef, () => setIsCopied(false))

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isCopied) setIsCopied(false)
    }, 1000)

    return () => clearTimeout(timeout)
  }, [isCopied])

  const handleCopyToClipboard = (label: string) => {
    copyToClipboard(label)
    setIsCopied(true)
  }

  if (isReady) {
    return (
      <div className={base} ref={divRef}>
        <a className={`${base}__description-link`} href={url}>
          {url}
        </a>

        <div
          className={clsx(
            `${base}__tooltip`,
            isCopied && `${base}__tooltip-active`,
          )}
        >
          <IconCopyText
            className={`${base}__icon-copy`}
            onClick={() => handleCopyToClipboard(url)}
          />
          <span
            className={clsx(
              `${base}__tooltip-text`,
              isCopied && `${base}__tooltip-active`,
            )}
            data-testid='tooltip-text'
          >
            {getLabel('common:copied.button')}
          </span>
        </div>
      </div>
    )
  }

  return <Fragment>-</Fragment>
}

export default CopyToClipboard
